"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel_1 = __importDefault(require("./DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var price_book_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/price_book_utils"));
var object_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/object_utils"));
var price_utils_1 = __importDefault(require("../../../common/src/utils/validation/price_utils"));
var apply_service_const_1 = __importDefault(require("../../../common/src/constrains/contract_form/apply_service_const"));
var Confirm = /** @class */ (function (_super) {
    __extends(Confirm, _super);
    function Confirm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Confirm.prototype.data = function () {
        return {
            tabletHeaders: [
                {
                    text: '商品名',
                    value: 'productName'
                },
                {
                    text: '単価',
                    value: 'unitPrice'
                },
                { text: '台数',
                    value: 'tabletNumbers'
                },
                { text: '合計',
                    value: 'total'
                }
            ],
            tabletItems: [
                {
                    productName: '',
                    unitPrice: 0,
                    tabletNumbers: 0,
                    total: 0
                }
            ]
        };
    };
    Confirm.prototype.submit = function (event) {
        event.preventDefault();
        this.$emit('submit-complete');
    };
    Confirm.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    Confirm.prototype.isEkycMainPlan = function () {
        var _this = this;
        // eKYC対応プランの場合は、trueを返す。
        var needToEkycMainPlan = [apply_service_const_1.default.ENTRY,
            apply_service_const_1.default.STANDARD,
            apply_service_const_1.default.OLD_STANDARD,
            apply_service_const_1.default.MEDIUM,
            apply_service_const_1.default.PROFESSIONAL,
            apply_service_const_1.default.UPGRADE];
        return needToEkycMainPlan.filter(function (el1) { return _this.formData.applyInfoApplyService.includes(el1); }).length > 0;
    };
    Confirm.prototype.isPersonalEkycSkip = function () {
        if (value_checker_1.default.isPresent(this.formData.personalEkycSkipFlg)) {
            return true;
        }
        else {
            return false;
        }
    };
    Confirm.prototype.parseDateToNengetu = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStrNenGetu(dateStr);
    };
    Confirm.prototype.isKobetuPlanSelectable = function () {
        return price_book_utils_1.default.isSelectableProduct(this.formData.kobetuPriceBook2Id);
    };
    Confirm.prototype.isOralCarePlanSelectable = function () {
        return price_book_utils_1.default.isSelectableProduct(this.formData.oralCarePriceBook2Id);
    };
    Confirm.prototype.isShowKobetuBikoLink = function () {
        return value_checker_1.default.isPresent(this.formData.kobetuPriceBookUrl);
    };
    Confirm.prototype.isShowBasicBikoLink = function () {
        return value_checker_1.default.isPresent(this.formData.basicPriceBookUrl);
    };
    Confirm.prototype.isShowStandardBikoLink = function () {
        return value_checker_1.default.isPresent(this.formData.standardPriceBookUrl);
    };
    Confirm.prototype.isShowOralCareBikoLink = function () {
        return value_checker_1.default.isPresent(this.formData.oralCarePriceBookUrl);
    };
    Confirm.prototype.isShowToUpgradeLimitedPreviousPlanName = function () {
        return object_utils_1.default.limitedPlanTexts("apply_info_previous_plan", this.formData.toUpgradeData, this.formData.toUpgradeSelectedItem, this.formData.previousPlan, '', this.formData.toUpgradeStartDate);
    };
    Confirm.prototype.isShowToUpgradeLimitedAfterPlanName = function () {
        return object_utils_1.default.limitedPlanTexts("apply_info_after_plan", this.formData.toUpgradeData, this.formData.toUpgradeSelectedItem, this.formData.previousPlan, this.formData.contractPlan, this.formData.toUpgradeStartDate);
    };
    Confirm.prototype.getKobetuPlanName = function () {
        if (this.isKobetuPlanSelectable()) {
            return this.formData.applyInfoKinoKunrenPeriod;
        }
        return object_utils_1.default.getApplyPlanText(this.formData.kobetuProductPlanName, this.formData.kobetuPriceBook2Description);
    };
    Confirm.prototype.getBasicPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.formData.basicProductPlanName, this.formData.basicPriceBook2Description);
    };
    Confirm.prototype.getEntryPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.formData.entryProductPlanName, this.formData.entryPriceBook2Description);
    };
    Confirm.prototype.getOldStandardPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.formData.oldStandardProductPlanName, this.formData.oldStandardPriceBook2Description);
    };
    Confirm.prototype.getMediumPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.formData.mediumProductPlanName, this.formData.mediumPriceBook2Description);
    };
    Confirm.prototype.getStandardPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.formData.standardProductPlanName, this.formData.standardPriceBook2Description);
    };
    Confirm.prototype.getProfessionalPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.formData.professionalProductPlanName, this.formData.professionalPriceBook2Description);
    };
    Confirm.prototype.getMotionAiPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.formData.motionAiProductPlanName, this.formData.motionAiPriceBook2Description);
    };
    Confirm.prototype.getUpgradeToStandardPlanName = function () {
        var productPlanName = "Rehab Cloud Standard アップグレード ";
        productPlanName += object_utils_1.default.getApplyPlanText(this.formData.standardProductPlanName, this.formData.standardPriceBook2Description);
        return productPlanName;
    };
    Confirm.prototype.getOralCarePlanName = function () {
        if (this.isOralCarePlanSelectable()) {
            return this.formData.applyInfoOralCarePeriod;
        }
        return object_utils_1.default.getApplyPlanText(this.formData.oralCareProductPlanName, this.formData.oralCarePriceBook2Description);
    };
    Confirm.prototype.back = function (step) {
        this.$emit('on-back', {}, step);
    };
    Confirm.prototype.getKobetuPrice = function () {
        if (!this.isShowKobetuPrice()) {
            return '';
        }
        if (price_book_utils_1.default.isNotStandardPriceBook(this.formData.kobetuPriceBook2Id)) {
            return this.getPriceStr(this.formData.kobetuPrice);
        }
        var priceBookData = price_book_utils_1.default.getKobetuProductData(this.formData.kobetuPriceBookData, this.formData.applyInfoApplyCapacity, object_utils_1.default.getSalesForcePeriod(this.formData.applyInfoKinoKunrenPeriod));
        return this.getPriceStr(String(priceBookData['price']));
    };
    Confirm.prototype.getBasicPrice = function () {
        return this.getPriceStr(this.formData.basicPrice);
    };
    Confirm.prototype.getEntryPrice = function () {
        return this.getPriceStr(this.formData.entryPrice);
    };
    Confirm.prototype.getOldStandardPrice = function () {
        return this.getPriceStr(this.formData.oldStandardPrice);
    };
    Confirm.prototype.getMediumPrice = function () {
        return this.getPriceStr(this.formData.mediumPrice);
    };
    Confirm.prototype.getStandardPrice = function () {
        return this.getPriceStr(this.formData.standardPrice);
    };
    Confirm.prototype.getProfessionalPrice = function () {
        return this.getPriceStr(this.formData.professionalPrice);
    };
    Confirm.prototype.getMotionAiPrice = function () {
        return this.getPriceStr(this.formData.motionAiPrice);
    };
    Confirm.prototype.getUpgradePrice = function () {
        return this.getPriceStr(this.formData.toUpgradePrice);
    };
    Confirm.prototype.getKobetuBiko = function () {
        var result = [];
        if (this.isShowKobetuBikoLink()) {
            result.push(this.formData.kobetuPriceBook2Description + "\u306E\u8A73\u7D30: " + this.formData.kobetuPriceBookUrl);
        }
        result.push(this.getBikoHtml(this.formData.kobetuTokubetuDetail));
        return result;
    };
    Confirm.prototype.getBasicBiko = function () {
        var result = [];
        if (this.isShowBasicBikoLink()) {
            result.push(this.formData.basicPriceBook2Description + "\u306E\u8A73\u7D30: " + this.formData.basicPriceBookUrl);
        }
        result.push(this.getBikoHtml(this.formData.basicTokubetuDetail));
        return result;
    };
    Confirm.prototype.getStandardBiko = function () {
        var result = [];
        if (this.isShowStandardBikoLink()) {
            result.push(this.formData.standardPriceBook2Description + "\u306E\u8A73\u7D30: " + this.formData.standardPriceBookUrl);
        }
        result.push(this.getBikoHtml(this.formData.standardTokubetuDetail));
        return result;
    };
    Confirm.prototype.getMotionAiBiko = function () {
        var result = [];
        // if (this.isShowMotionAiBikoLink()) {
        //     result.push(`${this.formData.basicPriceBook2Description}の詳細: ${this.formData.basicPriceBookUrl}`);
        // }
        result.push(this.getBikoHtml(this.formData.motionAiTokubetuDetail));
        return result;
    };
    Confirm.prototype.getUpgradeToStandardBiko = function () {
        var result = [];
        result.push(this.getBikoHtml(this.formData.upgradeToStandardTokubetuDetail));
        return result;
    };
    Confirm.prototype.getOralCareBiko = function () {
        var result = [];
        if (this.isShowOralCareBikoLink()) {
            result.push(this.formData.oralCarePriceBook2Description + "\u306E\u8A73\u7D30: " + this.formData.oralCarePriceBookUrl);
        }
        result.push(this.getBikoHtml(this.formData.oralCareTokubetuDetail));
        return result;
    };
    Confirm.prototype.getOralCarePrice = function () {
        if (!this.isShowOralCarePrice()) {
            return '';
        }
        if (price_book_utils_1.default.isNotStandardPriceBook(this.formData.oralCarePriceBook2Id)) {
            return this.getPriceStr(this.formData.oralCcarePrice);
        }
        var priceBookData = price_book_utils_1.default.getOralCareProductData(this.formData.oralCarePriceBookData, object_utils_1.default.getSalesForcePeriod(this.formData.applyInfoOralCarePeriod));
        return this.getPriceStr(String(priceBookData['price']));
    };
    Confirm.prototype.getPriceStr = function (price) {
        return price_utils_1.default.getPriceStr(price);
    };
    Confirm.prototype.isShowKobetuPrice = function () {
        return value_checker_1.default.isPresent(this.formData.kobetuPriceBook2Id);
    };
    Confirm.prototype.isShowKobetuTokubetuDetail = function () {
        return this.isShowKobetuBikoLink() ||
            value_checker_1.default.isPresent(this.formData.kobetuTokubetuDetail);
    };
    Confirm.prototype.isShowOralCareTokubetuDetail = function () {
        return this.isShowOralCareBikoLink() ||
            value_checker_1.default.isPresent(this.formData.oralCareTokubetuDetail);
    };
    Confirm.prototype.isShowOralCarePrice = function () {
        return value_checker_1.default.isPresent(this.formData.oralCarePriceBook2Id);
    };
    Confirm.prototype.isShowInputPrice = function () {
        return value_checker_1.default.isPresent(this.formData.inputPrice);
    };
    Confirm.prototype.getBikoHtml = function (bikoStr) {
        return object_utils_1.default.getBikoHtml(bikoStr);
    };
    Confirm.prototype.isShowKobetuPlanPeriod = function () {
        return value_checker_1.default.isPresent(this.formData.kobetuPriceBookMonth);
    };
    Confirm.prototype.getKobetuPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoKinoKunrenStartDate, this.formData.kobetuFreePeriod, this.formData.kobetuPriceBookMonth);
    };
    Confirm.prototype.getBasicPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoBasicStartDate, this.formData.basicFreePeriod, this.formData.basicPriceBookMonth, this.formData.basicProductPlanName);
    };
    Confirm.prototype.getEntryPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoEntryStartDate, this.formData.entryFreePeriod, this.formData.entryPriceBookMonth, this.formData.entryProductPlanName);
    };
    Confirm.prototype.getOldStandardPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoOldStandardStartDate, this.formData.oldStandardFreePeriod, this.formData.oldStandardPriceBookMonth, this.formData.oldStandardProductPlanName);
    };
    Confirm.prototype.getMediumPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoMediumStartDate, this.formData.mediumFreePeriod, this.formData.mediumPriceBookMonth, this.formData.mediumProductPlanName);
    };
    Confirm.prototype.getStandardPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoStandardStartDate, this.formData.standardFreePeriod, this.formData.standardPriceBookMonth, this.formData.standardProductPlanName);
    };
    Confirm.prototype.getProfessionalPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoProfessionalStartDate, this.formData.professionalFreePeriod, this.formData.professionalPriceBookMonth, this.formData.professionalProductPlanName);
    };
    Confirm.prototype.getMotionAiPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoMotionAiStartDate, this.formData.motionAiFreePeriod, this.formData.motionAiPriceBookMonth, this.formData.motionAiProductPlanName);
    };
    Confirm.prototype.getAdditionalTabletPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoAdditionalTabletStartDate, '', '1', 'tablet');
    };
    Confirm.prototype.isShowOralCarePlanPeriod = function () {
        return value_checker_1.default.isPresent(this.formData.oralCarePriceBookMonth);
    };
    Confirm.prototype.getOralCarePlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.formData.applyInfoOralCareSstartDate, this.formData.oralCareFreePeriod, this.formData.oralCarePriceBookMonth);
    };
    Confirm.prototype.isShowRequestInfoFixBtn = function () {
        return value_checker_1.default.isBlank(this.formData.requestInfoIsReadOnly);
    };
    Confirm.prototype.getApplyDate = function () {
        if (value_checker_1.default.isBlank(this.formData.applyInfoApplyDate)) {
            this.formData.applyInfoApplyDate = date_parser_1.default.toString(new Date());
        }
        return this.parseDate(this.formData.applyInfoApplyDate);
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], Confirm.prototype, "formData", void 0);
    Confirm = __decorate([
        vue_property_decorator_1.Component({
            components: {
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], Confirm);
    return Confirm;
}(vue_property_decorator_1.Vue));
exports.default = Confirm;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/contract_form/Confirm.vue
// module id = ehrC
// module chunks = 1